import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { Link } from '~/lib/react-router-dom';

import { Button, Skeleton } from '@mui/material';

import { getQuoteEmail } from '~/services/SailthruService';

type Props = {
  customerEmailDedupeKey: string;
};

export default function QuoteEmailSent({ customerEmailDedupeKey }: Props) {
  const { enqueueSnackbar } = useSnackbar();

  const {
    data: notificationId,
    isLoading,
    isError,
  } = useQuery<string, Error>({
    queryKey: ['quoteEmail', customerEmailDedupeKey],
    queryFn: async () => {
      const res = await getQuoteEmail(customerEmailDedupeKey);
      return res.result.notification_id;
    },
    enabled: !!customerEmailDedupeKey,
  });

  if (isLoading) {
    return <Skeleton width={100} />;
  }

  if (isError) {
    enqueueSnackbar('Error fetching email info', { variant: 'error' });
    return null;
  }

  if (!notificationId) {
    return null;
  }

  return (
    <Link to={`/email/render?id=${notificationId}`} target="_blank">
      <Button variant="text" size="small">
        View email
      </Button>
    </Link>
  );
}
